
export const removeFalseItems = (rolePermissions:any)=>{
    try{
      const roles:any = [...rolePermissions];
      let newRoles:any[] = [];
      roles.map((ele:any)=>{
        let obj:any ;
          if(ele.canAdd || ele.canEdit){
            obj = {...ele};
            if(!ele.canAdd){
              delete obj.canAdd;
            }
            if(!ele.canEdit){
              delete obj.canEdit;
            }
            newRoles.push(obj)
          }
      });
      return newRoles;     
      
    }catch(e){
        return rolePermissions;
    } 
  }